// =============================================================================
// FILE: packages/renderer/src/components/branding/FounderEditionBadge.tsx
// PURPOSE: The R2 Founder Edition badge — an elegant metallic-gold identity with
//   a subtle animated glow and five stars. Professional, not flashy.
// =============================================================================

import { type JSX } from 'react';

const GOLD_TEXT = 'linear-gradient(100deg,#8a6d1a 0%,#d4af37 32%,#f7ecb0 52%,#d4af37 68%,#8a6d1a 100%)';

export function FounderEditionBadge({ size = 'sm' }: { size?: 'sm' | 'md' }): JSX.Element {
  const fs = size === 'md' ? 12 : 7.5;
  const star = size === 'md' ? 10 : 7;
  return (
    <span
      data-testid="founder-edition-badge"
      className="founder-badge"
      style={{
        display: 'inline-flex', alignItems: 'center', gap: size === 'md' ? 8 : 5,
        padding: size === 'md' ? '4px 12px' : '2px 7px',
        borderRadius: 999,
        border: '1px solid rgba(212,175,55,0.55)',
        background: 'linear-gradient(180deg, rgba(40,32,8,0.6), rgba(20,16,4,0.6))',
      }}
    >
      <span
        style={{
          fontSize: fs, fontWeight: 800, letterSpacing: '0.18em', textTransform: 'uppercase',
          lineHeight: 1, whiteSpace: 'nowrap',
          background: GOLD_TEXT, WebkitBackgroundClip: 'text', backgroundClip: 'text',
          WebkitTextFillColor: 'transparent', color: 'transparent',
        }}
      >
        R2 Founder Edition
      </span>
      <span aria-hidden style={{ fontSize: star, letterSpacing: 1, lineHeight: 1, color: '#f0d873', textShadow: '0 0 4px rgba(212,175,55,0.6)' }}>
        ★★★★★
      </span>
    </span>
  );
}
